import { ToggleFeaturesContext } from 'contexts/toggleFeatures.context';
import type { FeatureKey } from 'models/features';
import { useContext } from 'react';

export function useToggleFeature(feature: FeatureKey): boolean {
  const toggleFeatures = useContext(ToggleFeaturesContext);
  return !!toggleFeatures && toggleFeatures[feature] === 'on';
}
